import { SelectionModel } from "@angular/cdk/collections";
import { DatePipe } from "@angular/common";
import { Component, HostListener, Inject, inject, OnInit, ViewChild } from "@angular/core";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { IonContent, AlertController, LoadingController } from "@ionic/angular";
import {
  contactListCompletedWithResponse,
} from "src/app/core-files/listing";
import { ToastComponent } from "src/app/core-files/loaders/toast-messages";
import { SharedService } from "src/app/core-files/shared.service.";
import { AgentCallingService } from "src/app/services/agent-calling.service";
import { LeadsService } from "src/app/services/leads.service";
import { SharedServices } from "src/app/services/shared.service";
import { ImportCallingContactComponent } from "src/app/shared-module/components/import-calling-contact/import-calling-contact.component";
import { WhatsAppMessageDialogComponent } from "src/app/shared-module/components/whatsapp-message-dialog/whatsapp-message-dialog.component";

import { Filesystem, Directory } from '@capacitor/filesystem';
import { Capacitor } from "@capacitor/core";
import { EncryptionService } from "src/app/services/encryption.service";
import { CustomMenuService } from "src/app/services/custom-menu";
export interface ExportCallingLeadsRequest {
  MainAgentId: any; // adjust type as needed
  // add other properties if required
}
@Component({
  selector: "app-tele-calling-user-list",
  templateUrl: "./tele-calling-user-list.page.html",
  styleUrls: ["./tele-calling-user-list.page.scss"],
  standalone: false,
})
export class TeleCallingUserListPage implements OnInit {
  @ViewChild('content', { static: false }) content: IonContent;

  searchContactText: string = "";
  isDataLoaded: boolean = false;
  searchText: string = "";
  teams = [];
  allTeam: string[] = [];
  employeeList: any = [];
  contactList: any;
  contactListCompleted: any;
  callingLeadsList: any = [];
  shoesSet = new Map();
  selected: any;
  selectedList: any = [];
  selectedValue: string = "Contact";
  displayedColumns: string[] = ["select", "name"];
  selection = new SelectionModel<any>(true, []);
  dataSource = new MatTableDataSource<any>([]);
  isAgent: any
  pageSizes = [15];
  readonly dialog = inject(MatDialog);

  skip: number = 0;
  take: number = 10;
  isLoadingMore: boolean = false;
  hasMoreData: boolean = true;

  tabIndex: number = 0;
  isLargeScreen: boolean = false;

  public getScreenWidth: any;
  public getScreenHeight: any;
  ActionPendingCount: any = 0;
  ActionTakenCount: any = 0;
  AllContactCount: any = 0;
  AssignContactCount: any = 0;
  AssignPendingCount: any = 0;
  isExpired: boolean = this.sharedServices.isExpired();
  selectedEmployeeIds: any[] = [];
  constructor(
    private leadService: LeadsService,
    private loadingController: LoadingController,
    private alertController: AlertController,
    private sharedServices: SharedServices,
    private agentCallingService: AgentCallingService,
    private sharedService: SharedService,
    private router: Router,
    private toastcomponent: ToastComponent,
    private encryptionService: EncryptionService

  ) { }

  ngOnInit() {
  }
  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.getScreenWidth = window.innerWidth;
    this.getScreenHeight = window.innerHeight;
    if (this.getScreenWidth > 768) {
      this.isLargeScreen = true;
    } else {
      this.isLargeScreen = false;
    }
  }
  goToSubscription() {
    this.router.navigate(["agent-home/my-account/subscription"]);
  }
  async whatsAppMessages(contactNumber: any) {
    if (!contactNumber) {
      this.toastcomponent.showToast("Mobile number not available!", "danger");
      return;
    }

    let digitsOnly = contactNumber.toString().replace(/\D/g, "");
    digitsOnly = digitsOnly.slice(-10);
    if (digitsOnly.length !== 10) {
      this.toastcomponent.showToast("Please enter 10 digit mobile number!", "danger");
      return;
    }

    this.dialog.open(WhatsAppMessageDialogComponent, {
      width: "720px",
      maxWidth: "95vw",
      autoFocus: false,
      hasBackdrop: true,
      backdropClass: "mat-dialog-blur-backdrop",
      data: {
        contactNumber: digitsOnly,
        mainAgentId: this.sharedServices.getAgentId(),
      },
    });
  }

  searchContactNumber() {
    if (this.searchContactText.trim() === "") {
      this.getContactList(this.tabIndex === 0 ? false : true);
    } else {
      this.agentCallingService.SearchActionTakenContactNumber(this.searchContactText,
        this.sharedServices.getAgentId()).subscribe({
          next: (res) => {
            this.contactList = res;
            this.dataSource = new MatTableDataSource(this.contactList);
          }, error: (err) => {
            this.toastcomponent.showToast("No contact found!", "danger");
          }
        });
    }
  }

  onSearchTextChange(event: any) {
    // this.searchText = event.detail.value;
    if (this.searchContactNumber.length === 0) {
      this.clearContactSearch();
    }
  }
  clearContactSearch() {
    // this.searchContactText = "";
    if (this.searchContactText.length === 0) {
      this.getContactList(false);
    } // No need to clear if already empty
    else {

    }

  }

  async downloadSampleFile() {
    const assetPath = 'assets/ImportCallingContact.xlsx'; // adjust if your file name/path differs
    const downloadName = 'ImportCallingContact.xlsx';
    // Implement your download logic here
    try {
      if (Capacitor.getPlatform() === 'web') {
        // Web: trigger browser download
        const link = document.createElement('a');
        link.href = assetPath;
        link.download = downloadName;
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.toastcomponent.showToast('Sample file download started', 'success');
      } else {
        // Native (Android / iOS via Capacitor): fetch asset and write to Documents
        const response = await fetch(assetPath);
        if (!response.ok) throw new Error('Asset fetch failed');
        const blob = await response.blob();
        const base64Data = await this.blobToBase64(blob);

        const nativeFileName = `ImportLeadsProperty_${Date.now()}.xlsx`;
        await Filesystem.writeFile({
          path: nativeFileName,
          data: base64Data,
          directory: Directory.Documents
        });

        this.toastcomponent.showToast(`Saved to Documents as ${nativeFileName}`, 'success');
      }
    } catch (err) {
      console.error('downloadSampleFile error', err);
      this.toastcomponent.showToast('Error downloading sample file', 'danger');
    }
  }
  private blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onerror = () => reject(reader.error);
      reader.onload = () => {
        const result = reader.result as string;
        const base64 = result.split(',')[1]; // strip "data:...;base64,"
        resolve(base64);
      };
      reader.readAsDataURL(blob);
    });
  }
  selectSignleValue(selectedOption: MatCheckboxChange) {
    const value = selectedOption.source.value;
    if (selectedOption.checked) {
      // Add value if checked and not already in the array
      if (!this.selectedList.includes(value)) {
        this.selectedList.push(value);
      }
    } else {
      // Remove value if unchecked
      this.selectedList = this.selectedList.filter((item) => item !== value);
    }
  }

  isAllSelected() {

    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numRows > 0 && numSelected === numRows;

  }
  onTabChanged(event) {
    this.selection.clear();
    this.selectedList = [];
    this.tabIndex = event.index;

    if (event.index === 0) {
      this.skip = 0; // Reset for initial load
      this.take = 100;
      this.getContactList(false)
      // this.dataSource = new MatTableDataSource(this.contactList);
    } else {
      this.skip = 0; // Reset for initial load
      this.take = 100;
      this.getContactList(true)
      // this.dataSource = new MatTableDataSource(this.contactListCompleted);
    }
  }


  ionViewWillEnter() {
    this.ContactCounts();
    this.sharedService.getCallingResponseSave.subscribe({
      next: (res) => {
        this.selectedList = [];
        this.getContactList(false);
      }
    })
    this.sharedService.getCallingContactLead.subscribe({
      next: (res) => {
        this.callingLeadsList = [];
        this.GetCallingLeads();
      }
    })
    // this.sharedService.getCallingContactAssign.subscribe((res) => {
    //   
    //   this.getContactList(false);
    // })
    this.isAgent = this.sharedServices.isAgent();
    this.getContactList(false)
    this.getUserList();
    this.leadService.getUserChanged.subscribe({
      next: () => {
        this.getUserList();
      }
    });


  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      this.selectedList = [];
      return;
    }
    // Select all rows in the entire data set
    this.dataSource.data.forEach((row: any) => {
      this.selection.select(row);
      if (!this.selectedList.includes(row.Id)) {
        this.selectedList.push(row.Id);
      }
    });
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? "deselect" : "select"} all`;
    }
    return `${this.selection.isSelected(row) ? "deselect" : "select"} row ${row.position + 1
      }`;
  }

  changeToggle(value) {
    this.tabIndex = 0;
    this.selectedValue = value;
    if (value === "Contact") {
      this.skip = 0; // Reset for initial load
      this.take = 100;
      this.getContactList(false);
    } else if (value == "Calling Leads") {
      this.GetCallingLeads()
    } else {
      this.getUserList();
    }
  }

  scrollToTop() {
    this.content.scrollToTop(500); // 500ms animation duration
  }

  GetCallingLeads() {
    let mainAgentId;
    mainAgentId = this.sharedServices.getAgentId();
    let agentUserId;

    let userRoleId;
    if (!this.sharedServices.isAgent()) {
      agentUserId = this.sharedServices.getAgentUserId();
      userRoleId = this.sharedServices.getAgentRole();
    }
    else {
      agentUserId = 0;
      userRoleId = 0;
    }
    this.agentCallingService.CallingAgentLeadList(mainAgentId, agentUserId, userRoleId, 0, 10).subscribe({
      next: (res) => {
        this.callingLeadsList = res;
        this.isDataLoaded = true;
        // this.setPeginator();
      },
      error: (err) => {
      }
    });
  }

  assignNumber() {
    const dialogRef = this.dialog.open(AssignContactDialog, {
      data: { selectedCount: this.selectedList },
      hasBackdrop: true,
      disableClose: true,
      autoFocus: false,
      backdropClass: "mat-dialog-blur-backdrop",
    });

    dialogRef.afterClosed().subscribe({
      next: (result) => {
      }
    });
  }
  loadMoreData(event?: any) {
    if (!this.hasMoreData || this.isLoadingMore) {
      if (event) event.target.complete();
      return;
    }

    this.skip += this.take;
    this.getContactList(this.tabIndex === 0 ? false : true, true);

    if (event) {
      setTimeout(() => {
        event.target.complete();
      }, 1000);
    }
  }

  importContact() {
    if (this.sharedServices.isExpired()) {
      const dialogRef = this.dialog.open(ImportCallingContactComponent, {
        data: { selectedCount: this.selectedList },
        hasBackdrop: true,
        disableClose: true,
        autoFocus: false,
        backdropClass: "mat-dialog-blur-backdrop",
      });

      dialogRef.afterClosed().subscribe({
        next: (result) => {
        }
      });
    } else {
      this.router.navigate(["agent-home/my-account/subscription"]);
    }
  }
  goToDetail(state: any, item: any) {
    this.router.navigate(["agent-home/user-contact",
      this.encryptionService.encryptUsingAES256(state),
      this.encryptionService.encryptUsingAES256(item.Id),
      this.encryptionService.encryptUsingAES256(item.Name)]);
  }

  async resetCallingResponse(item: any) {
    const alert = await this.alertController.create({
      header: 'Reset data',
      message: `Reset calling response data for ${item?.Name || 'this employee'}?`,
      buttons: [
        { text: 'Cancel', role: 'cancel' },
        {
          text: 'Reset',
          role: 'destructive',
          handler: async () => {
            const loading = await this.loadingController.create({
              cssClass: 'my-custom-class',
              message: 'Please Wait...',
            });
            await loading.present();

            const payload = {
              MainAgentId: this.sharedServices.getAgentId(),
              AgentUserId: item?.Id,
            };

            this.agentCallingService.RemoveCallingResponse(payload).subscribe({
              next: async () => {
                await loading.dismiss();
                this.toastcomponent.showToast('Calling response reset successfully', 'success');
                this.ContactCounts();
                this.getUserList();
              },
              error: async () => {
                await loading.dismiss();
                this.toastcomponent.showToast('Failed to reset calling response', 'danger');
              },
            });
          },
        },
      ],
    });

    await alert.present();
  }


  async getContactList(value, isLoadMore = false) {
    if (this.isLoadingMore) return; // Prevent multiple calls

    this.isLoadingMore = true;

    if (!isLoadMore) {
      this.skip = 0; // Reset for initial load
      this.contactList = []; // Clear existing data
    }

    const loadingCtrl = await this.loadingController.create({
      cssClass: "my-custom-class",
      message: "Please Wait...",
    });

    // if (!isLoadMore) await loadingCtrl.present();
    let mainAgentId = this.sharedServices.getAgentId();
    let agentUserId = this.sharedServices.isAgent() ? 0 : this.sharedServices.getAgentUserId();
    let userRoleId = this.sharedServices.isAgent() ? 0 : this.sharedServices.getAgentRole();
    if (this.tabIndex === 0) {
      this.skip = 0; // Reset for initial load
      this.take = 100
      value = false;
    } else {
      value = true;
    }

    this.agentCallingService.GetContactList(mainAgentId, agentUserId, userRoleId, value, this.skip, this.take)
      .subscribe({
        next: async (res) => {
          if (isLoadMore) {
            this.contactList = [...this.contactList, ...res]; // Append new data
          } else {
            this.contactList = res; // Initial load
          }

          this.dataSource = new MatTableDataSource(this.contactList);
          this.isDataLoaded = true;
          this.isLoadingMore = false;

          // Check if there's more data
          this.hasMoreData = res.length === this.take;

          if (!isLoadMore) await loadingCtrl.dismiss();
        }, error: async err => {
          this.isLoadingMore = false;
          if (!isLoadMore) await loadingCtrl.dismiss();
        }
      });
  }
  async getUserList() {
    const loadingCtrl = await this.loadingController.create({
      cssClass: "my-custom-class",
      message: "Please Wait...",
    });
    await loadingCtrl.present();
    let mainAgentId;
    mainAgentId = this.sharedServices.getAgentId();
    let agentUserId;

    let userRoleId;
    if (!this.sharedServices.isAgent()) {
      agentUserId = this.sharedServices.getAgentUserId();
      userRoleId = this.sharedServices.getAgentRole();
    }
    else {
      agentUserId = 0;
      userRoleId = 0;
    }
    this.agentCallingService.GetContactUserList(mainAgentId, agentUserId, userRoleId).subscribe({
      next: async (res) => {

        this.employeeList = res;
        this.isDataLoaded = true;
        await loadingCtrl.dismiss();
      }, error: async (err) => {
        await loadingCtrl.dismiss();
      }
    });
    // this.leadService
    //   .GetAgentUserList(0, this.sharedServices.getAgentId())
    //   .subscribe(
    //     async (res) => {
    //       
    //       this.employeeList = res;
    //       this.isDataLoaded = true;
    //       await loadingCtrl.dismiss();
    //     },
    //   async (err) => {
    //       await loadingCtrl.dismiss();
    //     }
    //   );
  }
  takeAction(contactId: any, Response: any) {
    if (this.sharedServices.isExpired()) {
      const dialogRef = this.dialog.open(ResponseSaveDialog, {
        data: { contactId: contactId, type: 'Pending', Response: Response },
        hasBackdrop: true,
        disableClose: true,
        autoFocus: false,
        backdropClass: "mat-dialog-blur-backdrop",
      });

      dialogRef.afterClosed().subscribe({
        next: (result) => {
        }
      });
    } else {
      this.router.navigate(["agent-home/my-account/subscription"]);
    }
  }


  isAllEmployeesSelected(): boolean {
    return this.employeeList.length > 0 && this.selectedEmployeeIds.length === this.employeeList.length;
  }

  toggleAllEmployees(): void {
    if (this.isAllEmployeesSelected()) {
      this.selectedEmployeeIds = [];
    } else {
      this.selectedEmployeeIds = this.employeeList.map((e: any) => e.Id);
    }
  }

  isEmployeeSelected(item: any): boolean {
    return this.selectedEmployeeIds.includes(item.Id);
  }

  toggleEmployee(item: any): void {
    const index = this.selectedEmployeeIds.indexOf(item.Id);
    if (index === -1) {
      this.selectedEmployeeIds.push(item.Id);
    } else {
      this.selectedEmployeeIds.splice(index, 1);
    }
  }

  async assignNumbersToMultipleEmployees(): Promise<void> {
    if (this.selectedEmployeeIds.length === 0) {
      this.toastcomponent.showToast('Please select at least one employee.', 'warning');
      return;
    }
    const alert = await this.alertController.create({
      header: 'Assign Numbers',
      message: `Assign numbers to ${this.selectedEmployeeIds.length} selected employee(s)?`,
      inputs: [
        {
          name: 'contactCount',
          type: 'number',
          placeholder: 'Enter number of contacts (1–100)',
          min: 1,
          max: 100,
          attributes: { min: 1, max: 100, required: true }
        }
      ],
      buttons: [
        { text: 'Cancel', role: 'cancel' },
        {
          text: 'Assign',
          handler: async (data) => {
            const contactCount = data?.contactCount ? Number(data.contactCount) : null;
            if (!contactCount || contactCount < 1 || contactCount > 100) {
              this.toastcomponent.showToast('Please enter a valid number between 1 and 100.', 'warning');
              return false;
            }
            const loading = await this.loadingController.create({ message: 'Please wait...' });
            await loading.present();
            const payload = {
              mainAgentId: this.sharedServices.getAgentId(),
              employeeIds: this.selectedEmployeeIds.join(','),
              contactCount: contactCount
            };
            this.agentCallingService.AssignContactsToMultipleEmp(payload).subscribe({
              next: async () => {
                await loading.dismiss();
                this.toastcomponent.showToast('Numbers assigned successfully.', 'success');
                this.selectedEmployeeIds = [];
                this.getUserList();
              },
              error: async () => {
                await loading.dismiss();
                this.toastcomponent.showToast('Failed to assign numbers. Please try again.', 'danger');
              }
            });
          }
        }
      ]
    });
    await alert.present();

    // Real-time validation: disable Assign button and show error styling until input is valid
    setTimeout(() => {
      const alertEl = document.querySelector('ion-alert');
      if (!alertEl) return;
      const input = alertEl.querySelector('input') as HTMLInputElement;
      const assignBtn = alertEl.querySelectorAll('.alert-button')[1] as HTMLButtonElement;
      if (!input || !assignBtn) return;

      // Start disabled
      assignBtn.disabled = true;
      assignBtn.style.opacity = '0.4';
      assignBtn.style.pointerEvents = 'none';

      const validate = () => {
        const raw = input.value.trim();
        const val = Number(raw);
        const isValid = raw !== '' && !isNaN(val) && Number.isInteger(val) && val >= 1 && val <= 100;
        assignBtn.disabled = !isValid;
        assignBtn.style.opacity = isValid ? '1' : '0.4';
        assignBtn.style.pointerEvents = isValid ? 'auto' : 'none';
        if (raw === '') {
          input.style.outline = '';
          input.style.borderBottom = '';
        } else {
          input.style.outline = 'none';
          input.style.borderBottom = `2px solid ${isValid ? 'var(--ion-color-success, #2dd36f)' : 'var(--ion-color-danger, #eb445a)'}`;
        }
      };

      input.addEventListener('input', validate);
    }, 150);
  }

  async unassignAllNumbers() {
    const alert = await this.alertController.create({
      header: 'Unassign All Numbers',
      message: 'Are you sure you want to unassign all numbers from all employees?',
      buttons: [
        { text: 'Cancel', role: 'cancel' },
        {
          text: 'Unassign',
          handler: async () => {
            const loading = await this.loadingController.create({ message: 'Please wait...' });
            await loading.present();
            const mainAgentId = this.sharedServices.getAgentId();
            this.agentCallingService.UnassignAllContacts(mainAgentId).subscribe({
              next: async () => {
                await loading.dismiss();
                this.toastcomponent.showToast('All numbers unassigned successfully.', 'success');
                this.getUserList();
              },
              error: async () => {
                await loading.dismiss();
                this.toastcomponent.showToast('Failed to unassign numbers. Please try again.', 'danger');
              }
            });
          }
        }
      ]
    });
    await alert.present();
  }

  deleteUser(id) {
    if (this.selectedList.length > 0) {
      this.sharedService.deleteData(
        "contact",
        this.selectedList.join(","),
        "Delete Contact",
        "Are you sure you want to delete this contact?"
      );
    } else {
      this.sharedService.deleteData(
        "contact",
        id.toString(),
        "Delete Contact",
        "Are you sure you want to delete this contact?"
      );
    }
  }
  deleteLead(id) {
    this.sharedService.deleteData(
      "contact lead",
      id,
      "Delete Calling Lead",
      "Are you sure you want to delete this lead?"
    );
  }
  editLead(id) {
    // this.sharedService.deleteData(
    //   "user",
    //   Id,
    //   "Delete User",
    //   "Are you sure you want to delete this user?"
    // );
  }
  ContactCounts() {
    this.agentCallingService.ContactCounts(this.sharedServices.getAgentId()).subscribe({
      next: (res) => {
        this.ActionPendingCount = res.ActionPendingCount;
        this.ActionTakenCount = res.ActionTakenCount;
        this.AllContactCount = res.AllContactCount;
        this.AssignContactCount = res.AssignContactCount;
        this.AssignPendingCount = res.AssignPendingCount;

      }
    });
  }
  exportContactResponse() {
    const request: ExportCallingLeadsRequest = {
      MainAgentId: this.sharedServices.getAgentId(),
      // Add other properties as needed
    };
    // TODO: Implement export logic here
    this.sharedService.deleteData(
      "export response",
      request,
      "Export Contact Response",
      "Are you sure you want to export this contact response data?"
    );

    // Add your export logic or service call here
  }
  ExportCallingLeads() {
    const request: ExportCallingLeadsRequest = {
      MainAgentId: this.sharedServices.getAgentId(),
      // Add other properties as needed
    };
    // TODO: Implement export logic here
    this.sharedService.deleteData(
      "export calling leads",
      request,
      "Export Calling Leads",
      "Are you sure you want to export this calling leads data?"
    );
  }
}

@Component({
  selector: "dialog-content-example-dialog",
  templateUrl: "assign-contact.html",
  standalone: false,
})
export class AssignContactDialog {
  isDataLoaded: boolean = false;
  selectedValue: any;
  userList: any = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private leadService: LeadsService,
    private sharedServices: SharedServices,
    private sharedService: SharedService,
    private loadingController: LoadingController,
    private matDialog: MatDialog,
    private agentCallingService: AgentCallingService,
    private toastComponent: ToastComponent
  ) {
    this.getUserList();
  }
  async getUserList() {
    const loadingCtrl = await this.loadingController.create({
      cssClass: "my-custom-class",
      message: "Please Wait...",
    });
    await loadingCtrl.present();
    this.leadService
      .GetAgentUserList(0, this.sharedServices.getAgentId())
      .subscribe({
        next: async (res) => {

          this.userList = res;

          this.isDataLoaded = true;
          await loadingCtrl.dismiss();
        },
        error: async (err) => {
          await loadingCtrl.dismiss();
        }
      });
  }
  onSelectEvent(event) {
    this.selectedValue = event.detail.value;
  }
  async assign() {
    const loadingCtrl = this.loadingController.create({
      cssClass: "my-custom-class",
      message: "Please Wait...",
    });
    (await loadingCtrl).present();
    let assignObject: any = {
      MainAgentId: this.sharedServices.getAgentId(),
      AgentUserId: this.selectedValue.Id,
      UserRoleId: this.selectedValue.UserRoleId,
      ContactNumberId: this.data.selectedCount.toString(),
    }
    this.agentCallingService.AssignContactToEmp(assignObject).subscribe({
      next: async (res) => {
        (await loadingCtrl).dismiss();

        this.sharedService.setCallingResponseSave(true);
        this.toastComponent.showToast("Contact assigned successfully", "success");
        this.matDialog.closeAll();

      }, error: async err => {
        (await loadingCtrl).dismiss();
        this.toastComponent.showToast("Something went wrong", "danger");
      }
    });

  }
  cancel() {
    this.matDialog.closeAll();
  }

}

@Component({
  selector: "dialog-content-example-dialog",
  templateUrl: "response-save.html",
  standalone: false,
})
export class ResponseSaveDialog {
  responseSubmitList: any = [];
  isDataLoaded: boolean = false;
  selectedValueResponse: string[] = [];
  userList: any = [];
  isActivityLoaded: boolean = false;
  customActivityTypeList: any = [];
  selectedResponseValue: any;
  searchResponseText: string = '';

  get filteredResponseList(): any[] {
    const q = this.searchResponseText.trim().toLowerCase();
    if (!q) return this.responseSubmitList;
    return this.responseSubmitList.filter((item: any) =>
      item.name?.toLowerCase().includes(q)
    );
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private matDialog: MatDialog,
    private sharedServices: SharedServices,
    private toastComponent: ToastComponent,
    private router: Router,
    private agentCallingService: AgentCallingService,
    private datePipe: DatePipe,
    private sharedService: SharedService,
    private encryptionService: EncryptionService,
    private customMenuService: CustomMenuService,
    private loadingController: LoadingController,
  ) {
    this.GetCustomMenuList();
    this.selectedResponseValue = this.data.Response;
    if (this.data.Response) {
      this.selectedValueResponse = this.data.Response.split(',').map((s: string) => s.trim()).filter((s: string) => s);
    }
  }
  isChecked(name: string): boolean {
    return this.selectedValueResponse.includes(name);
  }
  onCheckboxChange(name: string, event: any) {
    if (event.detail.checked) {
      if (!this.selectedValueResponse.includes(name)) {
        this.selectedValueResponse.push(name);
      }
    } else {
      this.selectedValueResponse = this.selectedValueResponse.filter(v => v !== name);
    }
  }
  save() {
    let saveObject: any = {
      Id: 0,
      CallingContactAgentId: this.data.contactId,
      MainAgentId: this.sharedServices.getAgentId(),
      AgentUserId: this.sharedServices.getAgentUserId(),
      UserRoleId: this.sharedServices.getAgentRole(),
      Response: this.selectedValueResponse.join(', '),
      ResponseDateTime: this.datePipe.transform(new Date(), 'yyyy-MM-ddTHH:mm:ss'),
      Comment: ""
    }
    if (this.sharedServices.isAgent()) {
      saveObject.AgentUserId = 0;
      saveObject.UserRoleId = 0;
    } else {
      saveObject.AgentUserId = this.sharedServices.getAgentUserId();
      saveObject.UserRoleId = this.sharedServices.getAgentRole();
    }
    const navigationResponses = [
      "Intersted in New Project", "Intersted In Plot", "Intersted In Resale",
      "Intersted In Rental", "Rental Property Available", "Resale Property Available",
      "Plot For Sale", "Plot For Rent"
    ];
    if (this.selectedValueResponse.some(v => navigationResponses.includes(v))) {

      // this.sharedService.showToast("Response saved successfully", "success");
      this.matDialog.closeAll();

      setTimeout(() => {
        this.router.navigate(["agent-home/add-call-response-lead", this.encryptionService.encryptUsingAES256(this.data.contactId)]);
      });
    }

    this.agentCallingService.SaveContactReport(saveObject).subscribe({
      next: (res) => {
        setTimeout(() => {

          this.sharedService.setCallingResponseSave(true);
        });
        this.toastComponent.showToast("Response saved successfully", "success");
        this.matDialog.closeAll();
      }, error: async (err) => {
        this.toastComponent.showToast("Something went wrong", "danger");
      }
    });
  }
  cancel() {
    this.matDialog.closeAll();
  }
  goToCustomActivites(type: string) {
    this.matDialog.closeAll();
    this.router.navigate(["agent-home/custom-list", this.encryptionService.encryptUsingAES256(type)]);
  }
  async GetCustomMenuList() {
    const loading = await this.loadingController.create({
      cssClass: "my-custom-class",
      message: "Loading...",
    });
    await loading.present();

    setTimeout(() => {
      this.customMenuService.GetCustomMenuList(this.sharedServices.getAgentId(), "Calling").subscribe({
        next: (res) => {
          this.customActivityTypeList = [];
          this.responseSubmitList = [...contactListCompletedWithResponse];
          this.customActivityTypeList = res;
          this.customActivityTypeList.forEach((element: any) => {
            this.responseSubmitList.push({ id: this.responseSubmitList.length + 1, name: element.CustomMenuTitle })
          });
          loading.dismiss();
          this.isActivityLoaded = true;

        },
        error: (err) => {
          console.error(err);
          loading.dismiss();
          this.isActivityLoaded = true;
          this.responseSubmitList = [...contactListCompletedWithResponse];
        }
      });
    });

  }

}
